<template>
  <article class="shop-partner-block page-common">
    <div class="px-[25px]">
      <h2 class="solgan <ipad:hidden">
        這些美業店家，都在使用<span class="text-primary-100">美業歐巴</span
        >預約系統
      </h2>
      <h2 class="solgan ipad:hidden">
        這些美業店家，<br />
        都在使用<span class="text-primary-100">美業歐巴</span>預約系統
      </h2>
      <h3 class="sub-solgan">
        超過<span class="text-primary-100"> 1,200 間</span>店家、<br class="laptop:hidden" />
        <span class="text-primary-100">3,000 位</span>美業老師都在用的美業預約系統
      </h3>
    </div>

    <!-- <div
      class="px-[16px] mt-[50px] flex flex-col gap-[32px] overflow-x-auto <laptop:hidden"
    >
      <div v-for="chunk in items" class="flex gap-[27.52px] justify-center">
        <div v-for="item in chunk" :key="item.text" class="py-[10px]">
          <div class="item">
            <IconBubble
              class="icon-img"
              :scaleImg="false"
              :src="item.img"
              :alt="item.alt"
            />
          </div>
        </div>
      </div>
    </div> -->
    <carousel
      class="mt-[35px] <laptop:hidden"
      :items-to-show="1"
      :wrap-around="true"
      snapAlign="start"
    >
      <slide v-for="(chunk, idx) in items" :key="idx" class="py-[10px]">
        <div
          class="grid grid-cols-7 grid-rows-2 justify-center gap-col-[12.8px] gap-row-[20px]"
        >
          <div class="item" v-for="item in chunk" :key="item.alt">
            <IconBubble class="icon-img" :scaleImg="false" :src="item.img" :alt="item.alt" />
          </div>
        </div>
      </slide>

      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </carousel>
  
    <carousel
      class="mt-[35px] laptop:hidden"
      :items-to-show="1"
      :wrap-around="true"
      snapAlign="start"
    >
      <slide v-for="(chunk, idx) in mobileItems" :key="idx" class="py-[10px]">
        <div
          class="grid grid-cols-3 grid-rows-2 justify-center gap-col-[7.5px]"
        >
          <div class="item" v-for="item in chunk" :key="item.alt">
            <IconBubble class="icon-img" :scaleImg="false" :src="item.img" :alt="item.alt" />
          </div>
        </div>
      </slide>

      <template #addons>
        <Pagination />
      </template>
    </carousel>

    <!-- <carousel
      class="mt-[35px] <desktop:hidden"
      :items-to-show="perView"
      :wrap-around="true"
      snapAlign="start"
    >
      <slide v-for="item in items" :key="item.text" class="py-[10px]">
        <div class="item">
          <IconBubble class="icon-img" :src="item.img" :alt="item.alt" />
        </div>
      </slide>
    </carousel> -->
  </article>
  <!-- <div class="mt-[32px] tablet:(mt-[60px])">
    <router-link to="" class="more-btn">更多合作商家</router-link>
  </div> -->
</template>

<script setup>
import { ref, computed } from '@vue/reactivity'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import { useWindowSize } from '@vueuse/core'
import IconBubble from '@/components/IconBubble.vue'

import partner1 from '@/assets/aboutUs/partner/2025/1.webp'
import partner2 from '@/assets/aboutUs/partner/2025/2.webp'
import partner3 from '@/assets/aboutUs/partner/2025/3.webp'
import partner4 from '@/assets/aboutUs/partner/2025/4.webp'
import partner5 from '@/assets/aboutUs/partner/2025/5.webp'
import partner6 from '@/assets/aboutUs/partner/2025/6.webp'
import partner7 from '@/assets/aboutUs/partner/2025/7.webp'
import partner8 from '@/assets/aboutUs/partner/2025/8.webp'
import partner9 from '@/assets/aboutUs/partner/2025/9.webp'
import partner10 from '@/assets/aboutUs/partner/2025/10.webp'
import partner11 from '@/assets/aboutUs/partner/2025/11.webp'
import partner12 from '@/assets/aboutUs/partner/2025/12.webp'
import partner13 from '@/assets/aboutUs/partner/2025/13.webp'
import partner14 from '@/assets/aboutUs/partner/2025/14.webp'
import partner15 from '@/assets/aboutUs/partner/2025/15.webp'
import partner16 from '@/assets/aboutUs/partner/2025/16.webp'
import partner17 from '@/assets/aboutUs/partner/2025/17.webp'
import partner18 from '@/assets/aboutUs/partner/2025/18.webp'
import partner19 from '@/assets/aboutUs/partner/2025/19.webp'
import partner20 from '@/assets/aboutUs/partner/2025/20.webp'
import partner21 from '@/assets/aboutUs/partner/2025/21.webp'
import partner22 from '@/assets/aboutUs/partner/2025/22.webp'
import partner23 from '@/assets/aboutUs/partner/2025/23.webp'
import partner24 from '@/assets/aboutUs/partner/2025/24.webp'
import partner25 from '@/assets/aboutUs/partner/2025/25.webp'
import partner26 from '@/assets/aboutUs/partner/2025/26.webp'
import partner27 from '@/assets/aboutUs/partner/2025/27.webp'
import partner28 from '@/assets/aboutUs/partner/2025/28.webp'
import partner29 from '@/assets/aboutUs/partner/2025/29.webp'
import partner30 from '@/assets/aboutUs/partner/2025/30.webp'
import partner31 from '@/assets/aboutUs/partner/2025/31.webp'
import partner32 from '@/assets/aboutUs/partner/2025/32.webp'
import partner33 from '@/assets/aboutUs/partner/2025/33.webp'
import partner34 from '@/assets/aboutUs/partner/2025/34.webp'
import partner35 from '@/assets/aboutUs/partner/2025/35.webp'
import partner36 from '@/assets/aboutUs/partner/2025/36.webp'
import partner37 from '@/assets/aboutUs/partner/2025/37.webp'
import partner38 from '@/assets/aboutUs/partner/2025/38.webp'
import partner39 from '@/assets/aboutUs/partner/2025/39.webp'
import partner40 from '@/assets/aboutUs/partner/2025/40.webp'
import partner41 from '@/assets/aboutUs/partner/2025/41.webp'
import partner42 from '@/assets/aboutUs/partner/2025/42.webp'

const { width, height } = useWindowSize()
const perView = computed(() => {
  if (width.value < 450) return 2.5
  else if (width.value < 650) return 2.5
  else if (width.value < 750) return 3.5
  else if (width.value < 980) return 3.5
  return 5
})

const items = [
  [
    {
      img: partner1,
      alt: '詩威特台北錦州店',
    },
    {
      img: partner10,
      alt: 'VIETJOY 越悅穆髮美學館',
    },
    {
      img: partner11,
      alt: 'N Beauty',
    },
    {
      img: partner13,
      alt: 'Doris Nail 朵莉絲美甲',
    },
    {
      img: partner3,
      alt: 'Doll SPA',
    },
    {
      img: partner17,
      alt: 'Beauty Face',
    },
    {
      img: partner18,
      alt: 'Florence Salon',
    },
    {
      img: partner8,
      alt: '璞真璦美學診所',
    },
    {
      img: partner2,
      alt: '夏沐妍',
    },
    {
      img: partner24,
      alt: '丹蒂美甲',
    },
    {
      img: partner27,
      alt: 'MS.K BEAUTY 美學',
    },
    {
      img: partner25,
      alt: '約吧芳療健康工作室',
    },
    {
      img: partner19,
      alt: '布拉藝術美甲',
    },
    {
      img: partner9,
      alt: '水芙蓉堂',
    },
  ],
  [
    {
      img: partner16,
      alt: 'Relief 紓壓',
    },
    {
      img: partner4,
      alt: '伊啵 ( CYJ )',
    },
    {
      img: partner23,
      alt: '指尖童話',
    },
    {
      img: partner15,
      alt: '艾拾金耳',
    },
    {
      img: partner21,
      alt: 'Miyo 眉睫',
    },
    {
      img: partner20,
      alt: '美顏工場 Facia Ginza',
    },
    {
      img: partner14,
      alt: '郁美容',
    },
    {
      img: partner5,
      alt: '淬齒淨白中心',
    },
    {
      img: partner6,
      alt: '羅麗芬美容美體',
    },
    {
      img: partner12,
      alt: 'Donna Salon',
    },
    {
      img: partner30,
      alt: '珂蕾',
    },
    {
      img: partner35,
      alt: '皙妍',
    },
    {
      img: partner28,
      alt: 'Crisci 肌膚燈光師',
    },
    {
      img: partner26,
      alt: '好看美妍',
    },
  ],
  [
    {
      img: partner39,
      alt: 'Facial Beauty',
    },
    {
      img: partner37,
      alt: '悠米美學',
    },
    {
      img: partner41,
      alt: '輕奢韓式半永久美學',
    },
    {
      img: partner31,
      alt: '甯之美診所',
    },
    {
      img: partner7,
      alt: '居髮廊',
    },
    {
      img: partner33,
      alt: '瑪淇除毛',
    },
    {
      img: partner32,
      alt: '花・予韓式皮膚管理',
    },
    {
      img: partner22,
      alt: 'HDS',
    },
    {
      img: partner40,
      alt: 'HouseWe 女子私寓',
    },
    {
      img: partner38,
      alt: '痘趣保養美學',
    },
    {
      img: partner36,
      alt: 'No. 13',
    },
    {
      img: partner34,
      alt: 'SIS Beauty',
    },
    {
      img: partner29,
      alt: '大日子美學',
    },
    {
      img: partner42,
      alt: '梅玉美學',
    }
  ]
]

const mobileItems = [
  [
    {
      img: partner1,
      alt: '詩威特台北錦州店',
    },
    {
      img: partner10,
      alt: 'VIETJOY 越悅穆髮美學館',
    },
    {
      img: partner11,
      alt: 'N Beauty',
    },
    {
      img: partner8,
      alt: '璞真璦美學診所',
    },
    {
      img: partner2,
      alt: '夏沐妍',
    },
    {
      img: partner22,
      alt: 'HDS',
    },
  ],
  [
    {
      img: partner13,
      alt: 'Doris Nail 朵莉絲美甲',
    },
    {
      img: partner3,
      alt: 'Doll SPA',
    },
    {
      img: partner17,
      alt: 'Beauty Face',
    },
    {
      img: partner24,
      alt: '丹蒂美甲',
    },
    {
      img: partner26,
      alt: '好看美妍',
    },
    {
      img: partner25,
      alt: '約吧芳療健康工作室',
    },
  ],
  [
    {
      img: partner23,
      alt: '指尖童話',
    },
    {
      img: partner16,
      alt: 'Relief 紓壓',
    },
    {
      img: partner18,
      alt: 'Florence Salon',
    },
    {
      img: partner19,
      alt: '布拉藝術美甲',
    },
    {
      img: partner20,
      alt: '美顏工場 Facia Ginza',
    },
    {
      img: partner9,
      alt: '水芙蓉堂',
    }
  ],
  [
    {
      img: partner4,
      alt: '伊啵 ( CYJ )',
    },
    {
      img: partner5,
      alt: '淬齒淨白中心',
    },
    {
      img: partner6,
      alt: '羅麗芬美容美體',
    },
    {
      img: partner29,
      alt: '大日子美學',
    },
    {
      img: partner28,
      alt: 'Crisci 肌膚燈光師',
    },
    {
      img: partner21,
      alt: 'Miyo 眉睫',
    },
    
  ],
  [
    {
      img: partner27,
      alt: 'MS.K BEAUTY 美學',
    },
    {
      img: partner35,
      alt: '皙妍',
    },
    {
      img: partner14,
      alt: '郁美容',
    },
    {
      img: partner15,
      alt: '艾拾金耳',
    },
    {
      img: partner30,
      alt: '珂蕾',
    },
    {
      img: partner12,
      alt: 'Donna Salon',
    },
  ],
  [
    {
      img: partner39,
      alt: 'Facial Beauty',
    },
    {
      img: partner7,
      alt: '居髮廊',
    },
    {
      img: partner32,
      alt: '花・予韓式皮膚管理',
    },
    {
      img: partner33,
      alt: '瑪淇除毛',
    },
    {
      img: partner40,
      alt: 'HouseWe 女子私寓',
    },
    {
      img: partner36,
      alt: 'No. 13',
    },
  ],
  [
    {
      img: partner31,
      alt: '甯之美診所',
    },
    {
      img: partner38,
      alt: '痘趣保養美學',
    },
    {
      img: partner41,
      alt: '輕奢韓式半永久美學',
    },
    {
      img: partner34,
      alt: 'SIS Beauty',
    },
    {
      img: partner42,
      alt: '梅玉美學',
    },
    {
      img: partner37,
      alt: '悠米美學',
    },
  ]
]
</script>

<style scoped lang="postcss">
.banner-title {
  @apply relative bg-primary-100 text-white rounded-br-[20px] w-[fit-content] m-auto py-[9px] px-[50px];
}

.check-icon {
  @apply absolute left-[-27px] top-[-12px] h-[54px];
}

.item-text {
  @apply text-[20px] font-medium leading-[28.96px] tracking-[1px];
}

.item {
  @apply select-none;
}

.solgan {
  @apply font-bold text-[24px] leading-[34.75px] tracking-[1px] pb-0;
  @apply tablet:(text-[48px] leading-[69.5px] tracking-[1px]);
}

.sub-solgan {
  @apply text-[14px] leading-[20.75px] tracking-[1px] font-medium mt-[16px];
  @apply tablet:(text-[32px] leading-[46.34px] tracking-[1px] mt-[21px]);
}

.more-btn {
  @apply bg-secondary-100 text-white rounded-full py-[8px] px-[28px];
}

.icon-img {
  @apply w-[100px] h-[100px] tablet:(w-[129px] h-[129px]);
}

:deep(.carousel__pagination) {
  @apply relative bottom-[-24px];
  /* @apply mt-[44px]; */
}

:deep(.carousel__pagination-item button) {
  @apply h-[10px] bg-[#c9c9c9];
}

:deep(.carousel__pagination-button--active) {
  @apply !bg-primary-100;
}

:deep(.carousel__prev) {
  @apply bg-[#c2bcdf] w-[41.91px] h-[41.91px] left-[30px];
}
:deep(.carousel__next) {
  @apply bg-[#c2bcdf] w-[41.91px] h-[41.91px] right-[30px];
}
</style>
